<template>
<span v-if="showAddDoors()">
  <el-button id="btn-add-door" type="success" plain @click="dialogVisible = true" size="mini">{{ $t('door.addDoor') }}</el-button>
  <el-dialog
  :close-on-click-modal="false"
  v-on:open="handleOpen"
  :title="$t('door.addDoor')"
  :visible.sync="dialogVisible"
  width="65%"
  class="dialog-with-cols"
  :before-close="handleClose">
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('door.warehouse')" prop="warehouse">
                  <el-input
                  v-model="form.warehouse"
                  disabled
                  class="inline-input"
                  id="form-warehouse"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('door.number')" prop="number">
                  <el-input
                  v-model="form.number"
                  v-numeric-validation
                  maxlength="25"
                  class="inline-input"
                  id="form-number"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('door.receiving')" prop="farmName">
                  <el-select v-model="form.receiving" class="inline-input" size="mini">
                   <el-option :label="yes.label" :value="yes.value"></el-option>
                   <el-option :label="no.label" :value="no.value"></el-option>
                 </el-select>
              </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('door.outbound')"  prop="totalUnitss">
                  <el-select v-model="form.outbound" class="inline-input" size="mini">
                   <el-option :label="yes.label" :value="yes.value"></el-option>
                   <el-option :label="no.label" :value="no.value"></el-option>
                  </el-select>
              </el-form-item>
          </el-col>
      </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('door.addDoor') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('door.clear') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  computed: {
    ...mapGetters([
      'door',
      'user'
    ])
  },
  data() {
    return {
      yes: constants.STATUS_BOOLEAN.yes,
      no: constants.STATUS_BOOLEAN.no,
      dialogVisible: false,
      form: {
        warehouse: '',
        number: null,
        receiving: constants.STATUS_BOOLEAN.yes.value,
        outbound: constants.STATUS_BOOLEAN.yes.value
      },
      formRules: {
        number: [
          { required: true, message: this.$t('door.error.numberRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      done();
    },
    async submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('door/save', this.form)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.resetForm();
                this.$store.dispatch('door/search', {});
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.number = null;
      this.form.outbound = constants.STATUS_BOOLEAN.yes.value;
      this.form.receiving = constants.STATUS_BOOLEAN.yes.value;
      this.form.warehouse = this.user.warehouseCode;
    },
    showAddDoors() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_DOORS);
    }
  }
};
</script>
